import { toast } from 'react-toastify';
import ConfirmToast from './ConfirmToast.jsx';

export default function confirmarConToast({
    message,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    type = 'warn',
    options = {},
}) {
    return new Promise((resolve) => {
        let resuelto = false;
        let toastId;

        const resolverUnaVez = (valor) => {
            if (resuelto) {
                return;
            }
            resuelto = true;
            resolve(valor);
        };

        const cerrarYResolver = (valor) => {
            resolverUnaVez(valor);
            if (toastId) {
                toast.dismiss(toastId);
            }
        };

        const toastBuilder = typeof toast[type] === 'function' ? toast[type] : toast.warn;
        const onCloseOriginal = options.onClose;

        toastId = toastBuilder(
            <ConfirmToast
                message={message}
                onDecision={cerrarYResolver}
                confirmText={confirmText}
                cancelText={cancelText}
            />,
            {
                autoClose: false,
                closeButton: false,
                closeOnClick: false,
                draggable: false,
                position: 'top-center',
                ...options,
                onClose: (...args) => {
                    resolverUnaVez(false);
                    if (typeof onCloseOriginal === 'function') {
                        onCloseOriginal(...args);
                    }
                },
            }
        );
    });
}
